// 9fbef606107a605d69c0edbcd8029e5d
import ORDERDETAILS_CONSTANTS from '../OrderDetails.constants';

export const getOrderDetails = (payload = {}) => {
  return {
    type: ORDERDETAILS_CONSTANTS.GET_ORDERDETAILS,
    payload,
  };
};

export const setOrderDetails = (orderDetailsData) => {
  return {
    type: ORDERDETAILS_CONSTANTS.SET_ORDERDETAILS,
    payload: orderDetailsData,
  };
};

export const showLoader = () => {
  return {
    type: ORDERDETAILS_CONSTANTS.SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: ORDERDETAILS_CONSTANTS.HIDE_LOADER,
  };
};

export const setOrderDetailsError = (payload) => {
  return {
    type: ORDERDETAILS_CONSTANTS.SET_ORDER_DETAILS_ERROR,
    payload,
  };
};
